import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Output } from '@angular/core';
import { User, AccountSubHeadDetails } from '../../shared/user.model';
import { Search } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { EventEmitter } from 'selenium-webdriver';

@Component({
  selector: 'app-transaction-grid',
  templateUrl: './transaction-grid.component.html',
  styleUrls: ['./transaction-grid.component.css']
})
export class TransactionGridComponent implements OnInit {

  title = "Transaction List";
  isSearch: boolean;  
  itemsPerPage: number=5;
  totalItems: number;
  currentPage: number=1;
  expenditures:any={};
  Expenditure:any={};
  s: Search;
  constructor(private userService: RegistrationService, private route: ActivatedRoute, private router: Router, private errorHandler:ErrorHandler)  
  { 
    this.s=new Search();
    this.isSearch = false;
  }

  ngOnInit() {
    this.GetAllexpenditureDetails(this.itemsPerPage, 1);
  }
  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllexpenditureDetails(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllexpenditureDetails(this.itemsPerPage, pageNo);
  }

  onSearch(s,itemsPerPage: number, pageNo: number) 
 {
   debugger;   
   var searchText = this.s.SearchText;
   var searchCriteria = this.s.SearchCriteria;
   if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the search criteria and search text.", "warning");
  else
  {
    if (searchCriteria == "TransactionDate")
    {
      if (new Date(searchText).toString() == "Invalid Date")
      {          
        swal("Warning!", "Please enter search text in date format(yyyy-mm-dd).", "warning");
      } 
      else 
      {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.searchExpenditure(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data:any) => {
            debugger;
            this.expenditures = data.ExpenditureModels;
            this.totalItems = data.TotalItemsCount;           
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error:any) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
      } 
   }
   else 
   {
     document.getElementById('loader-spinner').style.display = "block";
     this.userService.searchExpenditure(searchCriteria, searchText, itemsPerPage, pageNo)
       .subscribe(
         (data:any) => {
           debugger;
           this.expenditures = data.ExpenditureModels;
           this.totalItems = data.TotalItemsCount;           
           this.currentPage = pageNo;
           document.getElementById('loader-spinner').style.display = "none";
         }, (error:any) => {
           document.getElementById('loader-spinner').style.display = "none";
           this.errorHandler.HandlerError(error);
         });
    }  
  }
 }
deleteExpenditure(expenditureId: number)
  {
    swal({
      title: 'Are you sure?',
      text: "You want to delete this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.deleteExpenditure(expenditureId).subscribe(
          (data:any) => {
            swal('','Expenditure Deleted!','success');
            this.GetAllexpenditureDetails(this.itemsPerPage, 1);
            this.s.SearchText = "";
            this.s.SearchCriteria = "";
          },(error) => {
            document.getElementById('loader-spinner').style.display="none";
            this.errorHandler.HandlerError(error);
          });
      }
    })  
  }

  GetAllexpenditureDetails(itemsPerPage: number, pageNo: number) 
  {
    document.getElementById('loader-spinner').style.display = "block";
    debugger;
    this.userService.getAllexpenditureDetails(itemsPerPage,pageNo)
      .subscribe(
        (data:any) => {
          this.expenditures=data.ExpenditureModels;          
          this.totalItems=data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/finance/transaction-grid/transaction-grid.component.ts